import * as React from 'react'
import { Route, Routes } from 'react-router-dom'
import VendorUserRequestForProposalsView from 'vendors/vendorUserRequestForProposals/VendorUserRequestForProposalsView'
import VendorManage from 'vendors/vendorManage/VendorManage'
import VendorFirstWizard from 'vendors/vendorWizard/VendorFirstWizard'
import VendorWizard from 'vendors/vendorWizard/VendorWizard'
import VendorAppBar from 'vendors/vendorAppBar/VendorAppBar'
import VendorWizardAppBar from 'vendors/vendorWizard/components/VendorWizardAppBar'
import UserFlowCompleted from 'vendors/components/UserFlowCompleted'
import { initTranslation } from 'app/translations/i18n'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { useGetMe } from 'vendors/vendorWizard/userBasicInfoStep/queries/useUserQuery'

const Vendors = () => {
  const { isLoading: isLoadingMe, data: user } = useGetMe()

  React.useEffect(() => {
    if (user) {
      initTranslation(user.language)
    } else {
      initTranslation('fi-FI')
    }
  }, [user])

  if (isLoadingMe) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <UserFlowCompleted>
      <Routes>
        <Route path="" element={
          <>
            <VendorAppBar />
            <VendorUserRequestForProposalsView />
          </>
        } />
        <Route path="manage/:vendorId/*" element={
          <>
            <VendorAppBar />
            <VendorManage />
          </>
        } />
        <Route path="first/wizard/*" element={
          <>
            <VendorWizardAppBar />
            <VendorFirstWizard />
          </>
        } />
        <Route path="wizard/*" element={
          <>
            <VendorWizardAppBar />
            <VendorWizard />
          </>
        } />
      </Routes>
    </UserFlowCompleted>
  )
}

export default Vendors
